import React from 'react';

import MonthYearDate from '../Fields/MonthYearDate';
import InputElement  from 'react-input-mask';
import FaCross       from 'react-icons/lib/fa/close';

let moment        = require('moment');
let Claim         = require('../Managers/Claim');
let ClaimTypes    = require('../Data/ClaimTypes');

const ClaimsModal = React.createClass({
    propTypes: {
        earliest : React.PropTypes.number,
        latest : React.PropTypes.number,
        closeFunction : React.PropTypes.func,
        resetClaimsQuestion : React.PropTypes.func,
        editClaim : React.PropTypes.func,
        addClaim : React.PropTypes.func,
    },

    getDefaultProps() {
        return {
            earliest : 2014,
            latest : 2016,
        };
    },

    getInitialState() {
        return {
            showModal: false,
            guid : '',
            type : 0,
            value : '',
            isShowAddedMessage : false,
            isEditing : false,
            isValid: false,
            hasError: false,
            errors: null,
            displayErrors: null
        };
    },

    flushState : function() {
        this.setState({
            isEditing : false,
            guid : '',
            type : '',
            value : '',
        });
        this.refs.MonthYearDate.setState({
            month : '',
            year : '',
        });
    },

    getUnansweredQuestions() {
        let unansweredQuestions = [];
        let fields = [
            {
                'field':'claim-month',
                'title':'Please enter a claim month'
            },
            {
                'field':'claim-year',
                'title':'Please enter a claim year'
            },
            {
                'field':'claimType',
                'title':'Please select a claim type'
            },
            {
                'field':'claimAmount',
                'title':'Please enter a claim amount'
            }
        ];
        fields.map(function(i) {
            if (!document.getElementById(i.field).value || (i.field == 'claimType' && document.getElementById(i.field).value == 0)) {
                unansweredQuestions.push(i.title);
            }
        });
        return unansweredQuestions;
    },

    showClaimsModal : function(claim) {
        if (undefined != claim) {
            this.setState({
                isEditing : true,
                guid : claim.guid,
                type : claim.type,
                value : claim.value,
            });
            this.refs.MonthYearDate.setState({
                month : claim.month,
                year : claim.year,
            });
        } else {
            this.flushState();
        }
        this.setState({
            showModal : true
        });
    },

    hideClaimsModal : function() {
        let claims = Claim.get();
        if (claims == undefined || claims.length == 0) {
            this.props.resetClaimsQuestion();
        }
        this.setState({
            showModal : false,
            displayErrors: null
        });
    },

    addClaim : function() {
        this.setState({
            displayErrors: null
        });
        let errors = this.getUnansweredQuestions();
        if (errors.length > 0) {
            this.setState({
                displayErrors: errors
            });
            return false;
        }

        let claim = {
            type    : this.state.type,
            value   : this.state.value,
            month   : this.refs.MonthYearDate.state.month,
            year    : this.refs.MonthYearDate.state.year,
        };

        // add the claim via the parent
        this.props.addClaim(claim);

        // add message
        this.setState({
            isShowAddedMessage : true
        });
        setTimeout(() => {
            this.setState({
                isShowAddedMessage : false
            });
        }, 2000);

        // flush state here
        this.flushState();
    },

    updateInputType : function(e) {
        this.setState({
            type : e.target.value
        });
    },

    updateInputValue : function(e) {
        this.setState({
            value : e.target.value
        });
    },


    editClaim : function() {
        if (this.state.type == 0) {
            return false;
        }

        let claim = {
            guid    : this.state.guid,
            type    : this.state.type,
            value   : this.state.value,
            month   : this.refs.MonthYearDate.state.month,
            year    : this.refs.MonthYearDate.state.year,
        };

        // add the claim via the parent
        this.props.editClaim(claim);

        // add message
        this.setState({
            isShowEditedMessage : true
        });
        setTimeout(() => {
            this.setState({
                isShowEditedMessage : false
            });
        }, 2000);

        // flush state here
        this.flushState();
    },

    render() {
        let selectValue = this.state.selectValue;
        let claimTypes = ClaimTypes.default;
        let options = claimTypes.map(function(item) {
            if (selectValue === item.value) {
                return (
                    <option selected key={item.value} value={item.value}>{item.name}</option>
                );
            } else {
                return (
                    <option key={item.value} value={item.value}>{item.name}</option>
                );
            }
        });

        // set an earliest date range for years to limit the selectable values
        let earliest = parseInt(new moment().subtract(4, 'years').format('YYYY'));
        let latest = parseInt(new moment().format('YYYY'));

        let displayerrors = [];
        if (this.state.displayErrors !== null) {
            this.state.displayErrors.map(function(questionTitle) {
                displayerrors.push(<li>{questionTitle}</li>);
            }, this);
        }
        return (
            <modal-container class={this.state.showModal ? 'modal-active' : null}>
                <modal className="has-footer medium-width">
                    {this.state.displayErrors !== null ?
                        <div className="container pageValidationErrors">
                            <ul>{displayerrors}</ul>
                        </div>
                    : null }
                    <div className="modal-header">
                        {this.state.isEditing ?
                            <span>Edit Claim</span>
                        : <span>Add Claim</span>}
                        <a className="close-cross" onClick={this.hideClaimsModal}>
                            <FaCross />
                        </a>
                        {this.state.isShowAddedMessage ?
                            <div className="flash modal-flash">Claim Added</div>
                            : null}
                        {this.state.isShowEditedMessage ?
                            <div className="flash modal-flash">Claim Edited</div>
                            : null}
                    </div>
                    <div className="modal-body">
                        <div>
                            <MonthYearDate
                                ref="MonthYearDate"
                                earliestYear={earliest}
                                latestYear={latest}
                            />
                            <question-row>
                                <div className="question-main">
                                    <div className="question-header">
                                        <label htmlFor="claimType">Claim type</label>
                                    </div>
                                    <div className="question-input">
                                        <select value={this.state.type} onChange={this.updateInputType} name="claimType" id="claimType">{options}</select>
                                    </div>
                                </div>
                            </question-row>
                            <question-row>
                                <div className="question-main">
                                    <div className="question-header">
                                        <label htmlFor="claimAmount">Claim amount</label>
                                    </div>
                                    <div className="question-input">
                                        <div className="input-group money-group">
                                            <span className="input-group-addon left">&pound;</span>
                                            <InputElement
                                                name="claimAmount"
                                                id="claimAmount"
                                                mask="999999"
                                                value={this.state.value}
                                                onChange={this.updateInputValue}
                                                maskChar={null}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </question-row>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a onClick={this.hideClaimsModal}
                           className="btn btn-default pull-right">Cancel/Close</a>
                        {this.state.isEditing ?
                            <a onClick={this.editClaim} className="btn btn-success">Edit Claim</a>
                        : <a onClick={this.addClaim} className="btn btn-success">Add Claim</a>}
                    </div>
                </modal>
            </modal-container>
        );
    }
});

export default ClaimsModal;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/ClaimsModal.js
 **/